import React, { Component } from 'react'
import ReactGA from 'react-ga'
import { detectPassiveEventSupport } from '../../helpers'
import SectionWrapper from '../../Components/SectionWrapper'
import { throttle } from 'lodash'
import classnames from 'classnames'
import arrow from '../../assets/foam-arrow.svg'

class HomeZones extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentSectionKey: this.props.content[0].key,
      alertIsOpen: false,
      isModalOpen: false,
      vidPlay: false
    }
    this.mounted = false
    this.ticking = false
    this.autoPlay = false
    this.lastScrollY = 0
    this.numSlides = 0
    this.props.content.forEach(s => {
      if (s.key === 'mapStory') {
        this.numSlides = s.steps.length
      }
    })
    this.sectionList = this.props.content
  }

  componentWillMount = () => {
    this.mounted = true
    window.scrollTo(0, 0)
    const options = { passive: detectPassiveEventSupport() }
    window.addEventListener('scroll', this.onScroll, options)
  }

  componentWillUnmount = () => {
    this.mounted = false
    window.removeEventListener('scroll', throttle(this.onScroll, 30))
  }

  componentDidMount = () => {
    this.mounted = true
    setTimeout(() => {
      this.setState({ alertIsOpen: true })
    }, 5000)
    this.setState({ vidPlay: true })
    this.update()
  }

  announceHeight = (referenceKey, index, height, fromTop) => {
    const newSectionList = [...this.sectionList]
    newSectionList[index].height = height
    newSectionList[index].fromTop = fromTop
    this.sectionList = newSectionList
  }

  announceCurrentSection = (y, sections) => {
    const currentSection = sections.filter(
      (s, i) => y > s.fromTop && y < s.fromTop + s.height
    )
    if (currentSection[0]) {
      const currentSectionKey = currentSection[0].key
      if (currentSectionKey !== this.state.currentSectionKey) {
        this.setState({ currentSectionKey })
      }
    }
  }

  update = () => {
    if (!this.mounted) {
      return
    }
    const sections = this.sectionList
    const lastScrollY = this.lastScrollY
    // const iw = window.innerWidth
    const ih = window.innerHeight
    sections.forEach(s => {
      if (s.key === 'mapStory') {
        // this is tricky and has to match the css
        const startY = s.fromTop
        const stopY = startY + (this.numSlides - 1) * ih
        this.updateMapStickiness(lastScrollY, startY, stopY)
        this.updateMapStoryIndex(lastScrollY, s, startY, stopY)
      }
    })

    this.props.updateHeaderStyle(lastScrollY, sections)
    this.announceCurrentSection(lastScrollY, sections)
    this.ticking = false
  }

  // don't try to do stuff when stuff is already happening
  requestTick = () => {
    if (!this.ticking) {
      window.requestAnimationFrame(this.update)
      this.ticking = true
    }
  }

  onScroll = () => {
    this.lastScrollY = window.scrollY
    this.requestTick()
  }

  handleMailinglistClicked = () => {
    ReactGA.event({
      category: 'cta_click',
      action: 'alert_mailing_list'
    })
  }

  render() {
    const { currentSectionKey, vidPlay } = this.state
    const sections = this.props.content.map((section, index) => {
      const Child = section.component
      switch (section.key) {
        case 'hero':
          return (
            <SectionWrapper
              index={index}
              key={section.key}
              announceHeight={this.announceHeight}
              color={section.color}
              shadow={section.shadow}
              referenceKey={section.key}
              child={
                <Child
                  content={section}
                  isModalOpen={this.props.isModalOpen}
                  openModal={this.props.openModal}
                  closeModal={this.props.closeModal}
                  vidPlay={vidPlay}
                  currentSectionKey={currentSectionKey}
                />
              }
            />
          )
        default:
          return (
            <SectionWrapper
              index={index}
              key={section.key}
              announceHeight={this.announceHeight}
              color={section.color}
              shadow={section.shadow}
              referenceKey={section.key}
              child={
                <Child
                  content={section}
                  currentSectionKey={currentSectionKey}
                  vidPlay={vidPlay}
                />
              }
            />
          )
      }
    })
    return (
      <div className="zones">
        <div className="top">
          <div className="dot-left" />
          <div className="dot-right black" />
        </div>
        <div className="bottom">
          <div className="dot-left" />
          <div className="dot-right" />
        </div>
        <a
          className="persistent-sign-up"
          href="https://cqnllvd8gl2.typeform.com/to/EKlKIoEe"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="sign-up-button">
            <span>Sign up</span> <img src={arrow} alt="arrow" />
          </button>
        </a>
        {sections}
        <Alert
          isOpen={this.state.alertIsOpen}
          handleClose={() => this.setState({ alertIsOpen: false })}
          handleMailinglistClicked={this.handleMailinglistClicked}
        />
      </div>
    )
  }
}

const Alert = ({ isOpen, handleClose, handleMailinglistClicked }) => {
  const alertClasses = classnames({
    alertIsOpen: isOpen,
    alertIsClosed: !isOpen,
    alert: true
  })
  return <div className={alertClasses} />
}

export default HomeZones



// WEBPACK FOOTER //
// ./src/Views/Home/HomeZones.js